import { useTranslation } from 'react-i18next';

import { useCountries } from '@/hooks';
import { OpportunityItemList } from '@/features/opportunities/types';
import { Table } from '@tanstack/react-table';
import { TableFilterDropdown } from './table-filter-dropdown';

export type CountryFilterProps = {
  readonly table: Table<OpportunityItemList>;
  readonly value?: string[];
  readonly onChange: (value: string[]) => void;
  readonly popoverFilter?: boolean;
};

export function CountryFilter({ table, value, onChange, popoverFilter }: CountryFilterProps) {
  const { t } = useTranslation(['home']);

  const { options: countries } = useCountries();

  return (
    <TableFilterDropdown
      column={table.getColumn('country')!}
      title={t('Country')}
      options={countries}
      value={value}
      onChange={onChange}
      popoverFilter={popoverFilter}
    />
  );
}
